var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00012207 13.5C0.000122225 11.7272 0.34931 9.97167 1.02775 8.33377C1.70619 6.69588 2.70059 5.20765 3.95418 3.95406C5.20777 2.70047 6.696 1.70606 8.3339 1.02762C9.9718 0.349187 11.7273 -6.55159e-07 13.5001 0C15.273 6.55161e-07 17.0285 0.349189 18.6664 1.02763C20.3042 1.70607 21.7925 2.70047 23.0461 3.95406C24.2997 5.20765 25.2941 6.69588 25.9725 8.33378C26.6509 9.97168 27.0001 11.7272 27.0001 13.5L13.5001 13.5L0.00012207 13.5Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2501 12.5H15.2501V10.4999H13.2501V12.5ZM12.2758 2.53587C12.78 2.1787 13.3997 2 14.1347 2C15.1005 2 15.9029 2.25381 16.5418 2.76165C17.1806 3.26931 17.5001 4.02153 17.5001 5.01822C17.5001 5.62927 17.3616 6.14408 17.0846 6.56252C16.9226 6.81644 16.6115 7.14081 16.1512 7.53555L15.6974 7.92342C15.1553 8.38744 15.2123 8.85205 15.2051 9.496H13.2501C13.2501 8 13.616 7.51442 14.4456 6.80226L14.9123 6.40033C15.0656 6.27346 15.1892 6.13471 15.283 5.9843C15.4534 5.72568 15.5386 5.44125 15.5386 5.13095C15.5386 4.77366 15.4438 4.44813 15.254 4.15434C15.0644 3.86054 14.7179 3.71359 14.2149 3.71359C13.7203 3.71359 13.3695 3.89455 13.1628 4.25657C12.956 4.61866 13.0001 5.10969 13.0001 5.5H11.0001C11.0514 4.1602 11.4766 3.09539 12.2758 2.53587Z",
    fill: "#CDCDCD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.0001,
    y: 18,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0001,
    y: 24,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.00012,
    y: 21,
    width: 21,
    height: 3,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00012207,
    y: 18,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00012207,
    y: 24,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBone);
export default __webpack_public_path__ + "static/media/bone.f3edd83d2904aab68582d537c6156060.svg";
export { ForwardRef as ReactComponent };